import { DocumentModel } from 'api/documents/documents.model';
import { CertificateDetailsModel } from 'models/certificate.model';

export const getProductIdsOptions = (rows?: DocumentModel<CertificateDetailsModel>[]) =>
  rows
    ?.reduce<string[]>((prev, next) => {
      if (next.additionalDetails?.productId && !prev.includes(next.additionalDetails.productId)) {
        prev.push(next.additionalDetails.productId);
      }
      return prev;
    }, [])
    ?.map((productId) => ({
      value: productId,
      label: productId,
    }));
